import { Box, Button, Grid, Typography } from '@mui/material';
import { ComponentProps } from 'react';

export const getGridContainerStyle = (): ComponentProps<typeof Grid> => ({
  flexDirection: 'column',
  spacing: 2,
});

export const getDirectCallExplanationStyle = (): ComponentProps<
  typeof Typography
> => ({
  color: 'grey',
});

export const getSubmitButtonStyle = (): ComponentProps<typeof Button> => ({
  variant: 'contained',
  sx: {
    textTransform: 'none',
  },
});

export const getDialogBoxStyle = (): ComponentProps<typeof Box> => ({
  p: 1.5,
});

export const getDialogExitStyle = (): ComponentProps<typeof Button> => ({
  variant: 'outlined',
  color: 'primary',
  sx: {
    textTransform: 'none',
    mr: 1,
  },
});

export const getDialogConfirmStyle = (): ComponentProps<typeof Button> => ({
  variant: 'contained',
  color: 'primary',
  sx: {
    textTransform: 'none',
  },
});
